import { defineMessages } from 'react-intl';

export default defineMessages({
	featuredArticlesHeading: {
		defaultMessage: 'Featured articles',
		description: 'Heading for the featured articles section.',
		id: 'cv.categories.page.featured-articles.heading',
	},
	moreArticlesHeading: {
		defaultMessage: 'More articles',
		description: 'Heading for the featured articles section.',
		id: 'cv.categories.page.more-articles.heading',
	},
	articlesEmptyStateText: {
		defaultMessage:
			'There are no articles in this category yet. Try another category, or raise a request below.',
		description:
			'The text is shown as the body message in the empty state of the article list on a knowledge category page, displayed when no articles exist in the selected category.',
		id: 'cv.categories.page.no.articles.message',
	},
	categoriesEmptyStateLink: {
		defaultMessage: 'Back to {portalName}',
		description:
			'The text is shown as a back navigation link in the empty state of the article list on a knowledge category page. The placeholder {portalName} will be substituted with the name of the current portal.',
		id: 'cv.categories.page.no.articles.back.link',
	},
});
